// components/home/CallToAction/index.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { CTAWrapper, CTAContainer, CTATitle, CTAText } from "./styles"
import { Button } from "../../../styles/components";

const CallToAction = () => {
	const navigate = useNavigate();

	return (
		<CTAWrapper>
			<CTAContainer>
				<CTATitle>Start Your Baby's Photo Journey Today</CTATitle>
				<CTAText>
					Join the happy families capturing their precious moments with
					our professional photography service.
				</CTAText>
				<Button size="large" onClick={() => navigate("/pricing")}>
					View Our Packages
				</Button>
			</CTAContainer>
		</CTAWrapper>
	);
};

export default CallToAction;